<template>
<div data-el="ViewFileList">
  <el-dialog
    :visible.sync="dialogVisible"
    width="70vw"
    :close-on-click-modal="false"
    append-to-body
    @close="onClose"
  >
    <div class="header">
      <!--            <el-button type="primary" @click="setMainComponent('Editor')">返回</el-button>-->
    </div>

    <div class="main">
      <el-table :data="pageData.list" border style="width: 100%;font-size: 12px;" height="60vh">
        <el-table-column prop="ID" label="#" width="100" />
        <el-table-column prop="FileName" label="文件名" >
          <template slot-scope="scope" >
            <el-link type="primary" @click="showViewFile(scope.row,1)">{{ scope.row.FileName }}</el-link>
          </template>
        </el-table-column>
        <!--                <el-table-column prop="URL" label="URL地址"></el-table-column>-->
        <el-table-column prop="DateTime" label="上传时间" width="150"></el-table-column>
        <el-table-column prop="Status" label="操作" width="200">
          <template slot-scope="scope" >
            <el-link type="primary"   @click="showViewFile(scope.row,1)">预览</el-link>&nbsp;&nbsp;&nbsp;
            <el-link type="primary"   @click="showViewFile(scope.row,2)">下载</el-link>&nbsp;&nbsp;&nbsp;
            <el-link type="primary"   @click="delFile(scope.row)">移除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                       :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                       @current-change="pageChange"></el-pagination>
      </div>
    </div>
  </el-dialog>
  <ViewFile ref="ViewFileRef" />

<!--  <el-link type="primary" @click="$refs.ViewFileListRef.UploadFile(data=>{form.files=data.FileID},form.files)">上传附件</el-link>-->
<!--  <el-link type="primary" v-if="form.files" @click="$refs.ViewFileListRef.show(form.files)">查看下载</el-link>-->
</div>
</template>

<script>
import ViewFile from "./ViewFile";
import Http from "../../../common/Http"
export default {
  name: "ViewFileList",
  components: {ViewFile},
  props: {
    multiple:{
      type:Boolean,
      default:true
    }
  },
  data(){
    return{
      dialogVisible:false,
      where:{file_id:0},
      pageData:{
        list:[],
        total:0,
        page:1,
        pageSize:15,
      },
      on_list_fc:null,
    }
  },
  methods:{
    getList() {
      const that=this;
      let _where=that.where;
      _where.page=that.pageData.page;
      _where.pageSize=that.pageData.pageSize;
      Http.get("/oss/SystemFile/getList",_where,ret=>{
        if(ret.code){
          that.pageData=ret.data;
        }
      })
    },
    pageChange(e) {
      this.pageData.page=e;
      this.getList()
    },
    show(file_id=0) {
      if(!file_id){
        this.$message.error("无文件")
        return false;
      }
      this.dialogVisible=true
      this.where.file_id=file_id;
      this.pageChange(1)
    },
    onClose() {
      this.dialogVisible=false;
      typeof this.on_list_fc === 'function' && this.on_list_fc(this.pageData.list);
      this.where.file_id=0;
      this.pageData.list=[];
      this.pageData.page=1;
      this.on_list_fc=undefined;
    },
    showViewFile(item,type=1){
      const that=this;
      if(type===1){
        this.$refs.ViewFileRef.show({
          width: '90vw',
          height:'80vh',
          title:item.FileName,
          src:item.URL,
          bucket:item.BucketName,
          duration_time:86400,
          download(){
            // window.open(file_url)
            __OSS__.setBucket(item.BucketName).setKey(item.URL).download();
          }
        })
      }else {
        // window.open(file_url)
        __OSS__.setBucket(item.BucketName).setKey(item.URL).download();
      }

      // __OSS__.setKey(item.URL).getUrl(file_url=>{
      //     if(type==1){
      //         ViewFileRef.value.show({
      //             width: '90vw',
      //             height:'80vh',
      //             title:item.FileName,
      //             src:file_url,
      //             download(){
      //                 // TODO 下载文件逻辑
      //                 window.open(file_url)
      //             }
      //         })
      //     }else {
      //         window.open(file_url)
      //     }
      // })


    },
    delFile(item) {
      const that=this;
      Http.post("/oss/SystemFile/delFile",{ID:item.ID},ret=>{
        if(ret.code){
          that.$message.success(ret.msg);
          that.pageChange(1)
        }else {
          that.$message.error(ret.msg);
        }
      })
    },
    UploadFile(callback,file_id=0) {
      if(!this.multiple){
        Http.uploadFile2(callback,file_id)
        return false;
      }
      Http.uploadFileToSystem(callback,file_id)
    },
    onList(callback){
      this.on_list_fc=callback;
    },

  }
}
</script>

<style lang="scss" scoped>
.main{
  height: 70vh;
  overflow-y: scroll;
  .pagination-wrap{
    display: table;
    /* text-align: center; */
    margin: 20px auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/ViewFileList.vue